/* Smooth thumbnail strips for the theme's own galleries (Concept slider-dots / media-dots).
   Concept scrolls the strip in transitionTo() on every slider:change, which fires when the page changes
   and again on scrollend. Two smooth scrolls right after each other made the strip jerk on iPhone.
   Now the strip only scrolls when the selected thumbnail is not fully visible, and once per selection. */
(() => {
  if (!window.customElements) return;
  customElements.whenDefined('slider-dots').then(() => {
    const Dots = customElements.get('slider-dots');
    if (!Dots || Dots.prototype.dkPatched) return;
    const original = Dots.prototype.transitionTo;
    Dots.prototype.transitionTo = function (selectedIndex, immediate = false) {
      const item = this.itemsToShow && this.itemsToShow[selectedIndex];
      const scroller = this.hasAttribute('align-selected') ? this.closest(this.getAttribute('align-selected')) : this;
      if (!item || !scroller) return;
      if (!immediate) {
        if (this.dkLastIndex === selectedIndex) return;
        this.dkLastIndex = selectedIndex;
        const s = scroller.getBoundingClientRect();
        const i = item.getBoundingClientRect();
        if (i.left >= s.left - 1 && i.right <= s.right + 1 && i.top >= s.top - 1 && i.bottom <= s.bottom + 1) return;
      } else {
        this.dkLastIndex = selectedIndex;
      }
      return original.call(this, selectedIndex, immediate);
    };
    Dots.prototype.dkPatched = true;
  });
})();
